<template>
    <div v-if="module" class="d-flex flex-row">
        <DeviceConnectionHistoryModal
            @closeModal="() => isDeviceConnectionHistoryModalOpen = false"
            :machine="machine"
            v-model="isDeviceConnectionHistoryModalOpen"
            :last_connection_history="last_connection_history" />
        <div class="card border-primary m-2" style="max-width: 700px;min-width: 700px">
            <div class="card-header d-flex flex-row justify-content-between navbar-height bg-primary">
                <h2 class="flex-grow-1 text-white p-1">{{ $t('Communication') }}</h2>
                <button v-if="last_connection_history"
                        class="btn text-light link"
                        @click="isDeviceConnectionHistoryModalOpen = true">
                    {{ $t('Connection History') }}
                </button>
            </div>
            <div class="card-body">
                <div class="card mb-4">
                    <div class="card-header"><h3>{{ $t('Module Info') }}</h3></div>
                    <div class="card-body">
                        <table class="table text-nowrap">
                            <tr>
                                <td class="text-end" style="width: 25%">{{ $t('Module serial') }}:</td>
                                <td class="text-start"><b>{{ module.serial }} ({{ module.version }})</b></td>
                            </tr>
                            <tr>
                                <td class="text-end" style="width: 25%">{{ $t('Module type') }}:</td>
                                <td class="text-start"><b>{{ module.type }}</b></td>
                            </tr>
                            <tr>
                                <td class="text-end" style="width: 25%">{{ $t('ICCID') }}:</td>
                                <td class="text-start"><b>{{ module.iccid }}</b></td>
                            </tr>
                            <tr v-if="last_connection_history">
                                <td class="text-end" style="width: 25%">{{ $t('Last connection') }}:</td>
                                <td class="text-start"><b>{{ dateAndTime(last_connection_history.end_time) }}</b></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {computed, ref} from "vue";
import {dateAndTime} from "../../../utilities/date";
import DeviceConnectionHistoryModal from "./DeviceConnectionHistoryModal.vue";

const props = defineProps({
    machine: {
        type: Object,
    },
});

const isDeviceConnectionHistoryModalOpen = ref(false);

const module = computed(() => {
    if (props.machine && props.machine.module) {
        return props.machine.module;
    }
})
const last_connection_history = computed(() => {
    if (props.machine && props.machine.last_connection_history) {
        return props.machine.last_connection_history;
    }
})
</script>
